import { Modal, Card, TabGroup, Tab, Button } from '@nike/eds';
import { useState, useEffect } from 'react';
import HotsearchClient from '../../clientAPI/hotsearch';

type RankingListPreviewProps = {
  itemId: string;
  showModal: boolean;
  onDismiss: () => void;
};

const channelOptions = [
  { value: '82a74ac1-c527-4470-b7b0-fb5f3ef3c2e2', label: 'Nike App' },
  { value: 'd9a5bc42-4b9c-4976-858a-f159cf99c647', label: 'Nike.COM' },
  { value: '15d92135-394e-487a-8afa-f6c8525c9ea9', label: 'WeChat' },
  { value: '008be467-6c78-4079-94f0-70e2d6cc4003', label: 'SNKRS' },
];

const topnum = 3;

export default function RankingListPreview(props: RankingListPreviewProps) {
  const [publishedItems, setPublishedItems] = useState<RankingList>();
  const [draftItems, setDraftItems] = useState<RankingList>();
  const [activeId, setActiveId] = useState('Draft');
  const [currentItems, setCurrentItems] = useState<RankingList>();

  useEffect(() => {
    fetchAndConvertToRankingDetail().then((response) => {
      setPublishedItems(response.published);
      setDraftItems(response.source);
      activeId === 'Published'
        ? setCurrentItems(response.published)
        : setCurrentItems(response.source);
    });
  }, [props.itemId]);

  async function fetchAndConvertToRankingDetail(): Promise<RankingDetail> {
    const response = await HotsearchClient.queryRankById(props.itemId);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const json: RankingDetail = await response.json();
    return json;
  }

  return (
    <Modal
      className='ranking-list-preview-modal'
      onDismiss={props.onDismiss}
      headerSlot={
        currentItems
          ? currentItems?.title == null
            ? 'No Title'
            : currentItems?.title
          : 'No Title'
      }
      //headerSlot=''
      isOpen={props.showModal}
    >
      <TabGroup
        name='tab-group'
        activeId={activeId}
        onChange={(e) => {
          e.target.id === 'Published'
            ? setCurrentItems(publishedItems)
            : setCurrentItems(draftItems);
        }}
      >
        <Tab id='Draft'>Draft</Tab>
        <Tab id='Published' className='tw-text-lg'>
          Published
        </Tab>
      </TabGroup>
      <div className='tw-flex tw-flex-col' style={{ padding: '20px' }}>
        {/* top 3 items */}
        <div className='tw-flex tw-gap-3  tw-mt-2 tw-w-[39rem]'>
          {currentItems?.items.slice(0, topnum).map((item, index) => {
            return (
              <TopThreeItems
                item={item}
                itemIndex={index}
                key={crypto.randomUUID()}
              />
            );
          })}
        </div>

        {/* top 4-9 items */}
        {currentItems && (
          <div className='tw-flex tw-flex-wrap tw-mt-2  tw-w-[39rem] tw-gap-6'>
            {currentItems?.items.slice(topnum).map((item, index) => {
              return (
                <TopFourToNineItems
                  item={item}
                  itemIndex={index}
                  key={crypto.randomUUID()}
                />
              );
            })}
          </div>
        )}

        {currentItems?.name && (
          <div className='tw-flex tw-mt-4 tw-w-[35rem]'>
            <span className='tw-text-sm tw-font-sans tw-font-medium tw-w-20 tw-text-left'>
              Name:
            </span>
            <span className='tw-text-sm tw-font-sans'>
              {currentItems?.name}
            </span>
          </div>
        )}
        {currentItems?.channelIds && currentItems?.channelIds.length > 0 && (
          <div className='tw-flex tw-mt-4 tw-w-[35rem] tw-text-left'>
            <span className='tw-text-sm tw-font-sans tw-font-medium  tw-w-20 tw-text-left'>
              Channels:
            </span>
            <span className='tw-text-sm tw-font-sans'>
              {currentItems?.channelIds
                .map((channelId, index) => {
                  const channelName = channelOptions.filter((channel) => {
                    if (channel.value === channelId) {
                      return channel.label;
                    }
                  });
                  return channelName[0].label;
                })
                .join('、')}
            </span>
          </div>
        )}

        {currentItems?.concepts && currentItems?.concepts.length > 0 && (
          <div className='tw-flex  tw-mt-4  tw-w-[35rem] tw-text-left'>
            <span className='tw-text-sm tw-font-sans tw-font-medium tw-w-20 tw-text-left'>
              Concepts:
            </span>
            <span className='tw-text-sm tw-font-sans'>
              {currentItems?.concepts
                .map((concept, index) => {
                  return concept.name;
                })
                .join('、')}
            </span>
          </div>
        )}
        {currentItems?.footnote && (
          <div className='tw-flex  tw-mt-4 tw-w-[35rem] tw-text-left'>
            <span className='tw-text-sm tw-font-sans tw-font-medium tw-w-20 tw-text-left'>
              Footnote:
            </span>
            <span className='tw-text-sm tw-font-sans '>
              {currentItems?.footnote}
            </span>
          </div>
        )}
        {currentItems?.ctaText && (
          <div className='tw-mt-4  tw-w-[35rem] tw-gap-1 tw-cursor-pointer tw-text-center'>
            <Button
              // disabled
              // disableRipple
              size='medium'
              variant='primary'
              onClick={() => console.log('pressed')}
            >
              {currentItems?.ctaText}
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
}

function TopThreeItems(props: { item: RankingItem; itemIndex: number }) {
  const item = props.item;
  return (
    <>
      <Card
        className='tw-mt-2 hover:tw-scale-105 tw-duration-300 tw-border tw-w-[200px]'
        key={props.itemIndex}
      >
        {item.image.portraitURL && (
          <img
            style={{ width: '80px', height: '100px' }}
            className='tw-rounded-[6px]'
            alt='FPO'
            src={item.image.portraitURL}
          />
        )}

        {!item.image.portraitURL && (
          <div
            style={{
              backgroundImage: `url(${item.background.portraitURL})`,
              backgroundSize: '80px 100px',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
            className='tw-flex tw-text-center tw-font-bold tw-w-[80px] tw-h-[100px] tw-leading-[100px] tw-justify-center tw-items-center'
          >
            <div className='tw-w-20 tw-h-20  tw-justify-center tw-items-center tw-flex'>
              <span
                style={{
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  display: 'inline-block',
                  lineHeight: 'normal',
                  textOverflow: 'ellipsis',
                  maxWidth: '100%',
                  height: 'auto',
                  maxHeight: '100%',
                  overflowWrap: 'break-word',
                  fontSize: '16px',
                }}
              >
                {item.liveText}
              </span>
            </div>
          </div>
        )}

        <div className='tw-w-[150px] tw-font-bold' style={{ fontSize: '15px' }}>
          {item.rank + '. ' + item.title}
        </div>
      </Card>
    </>
  );
}

function TopFourToNineItems(props: { item: RankingItem; itemIndex: number }) {
  const item = props.item;
  return (
    <>
      <Card
        className='tw-flex tw-gap-10 hover:tw-scale-105 tw-duration-300 tw-w-[300px] tw-border'
        key={props.itemIndex}
      >
        {props.item.image.squarishURL && (
          <img
            style={{ width: '80px', height: '80px' }}
            alt='FPO'
            src={item.image.squarishURL}
            className='tw-rounded-[6px]'
          />
        )}

        {!props.item.image.squarishURL && (
          <div
            style={{
              backgroundImage: `url(${item.background.squarishURL})`,
              backgroundSize: '80px 80px',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
            className='tw-flex tw-text-center tw-font-bold tw-w-[80px] tw-h-[80px] tw-leading-[80px] tw-justify-center tw-items-center'
          >
            <div className='tw-w-20 tw-h-20  tw-justify-center tw-items-center tw-flex'>
              <span
                style={{
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                  display: 'inline-block',
                  lineHeight: 'normal',
                  textOverflow: 'ellipsis',
                  maxWidth: '100%',
                  height: 'auto',
                  maxHeight: '100%',
                  overflowWrap: 'break-word',
                  fontSize: '16px',
                }}
              >
                {item.liveText}
              </span>
            </div>
          </div>
        )}

        <p className='eds-spacing--py-20'>
          <a
            href={item.deepLink}
            target='_blank'
            rel='noreferrer'
            className='tw-font-bold'
          >
            {item.rank + '. ' + item.title}
          </a>
        </p>
      </Card>
    </>
  );
}
